<template>
  <div class="wrapper">
    <div class="actBar">
      <el-button type="primary" icon="el-icon-upload2">导出</el-button>
      <el-input placeholder="搜索">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.wrapper {
}
</style>
